import {createSelector} from '@reduxjs/toolkit'

const confirmBeforePaymentSelector = createSelector(
    [state => state.components],
    ({confirmBeforePayment}) => {
        return confirmBeforePayment
    }
)

export const confirmBeforePaymentSelect = state => ({
    confirmBeforePayment: confirmBeforePaymentSelector(state)
})
